module.exports = __webpack_public_path__ + "assets/diamond.ebe56953.svg";